"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clone = require("@utiljs/clone");
var _ConfigProvider = require("../ConfigProvider");
var _zhCN = _interopRequireDefault(require("./lang/zh-CN"));
/**
 * eg:
 * lng('Modal.confirm')
 * lng('DatePicker.Month.jan')
*/

var _lang = _zhCN.default;
var _rtl = false;
var use = function use(lang) {
  _lang = lang;
};
var useRtl = function useRtl(rtl) {
  var _a;
  _rtl = rtl;
  var global = (0, _ConfigProvider.globalConfig)();
  var prefix = (_a = global === null || global === void 0 ? void 0 : global.prefixCls) !== null && _a !== void 0 ? _a : 'roo';
  if (_rtl) {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('class', "".concat(prefix, "-rtl"));
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('class', '');
  }
};
var lng = function lng(path) {
  var value = (0, _clone.cloneJSON)(_lang);
  var arr = path.split('.');
  arr.forEach(function (i) {
    // @ts-ignore
    value = value[i];
  });
  return value || '';
};
var rtl = function rtl() {
  return _rtl;
};
var _default = exports.default = {
  use: use,
  useRtl: useRtl,
  lng: lng,
  rtl: rtl
};